/**
 * Layout tokens for data tables — easy to relocate under `src/components/common/` later.
 */
export const dataTableShellClass =
  'bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden' as const;

export const dataTableScrollClass = 'overflow-x-auto' as const;

export const dataTableClass = 'w-full' as const;

export const headerCellLeftClass = 'text-left p-4 font-medium text-sm text-gray-600' as const;

export const headerCellCenterClass = 'text-center p-4 font-medium text-sm text-gray-600' as const;

export const bodyRowClass = 'border-b hover:bg-gray-50 transition-colors' as const;

export const theadClass = 'border-b bg-gray-50' as const;

export const bodyCellClass = 'p-4' as const;

export const sortableHeaderButtonClass =
  'inline-flex items-center gap-1 hover:text-gray-900 -mx-1 px-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1' as const;

export const actionIconButtonClass =
  'p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded' as const;

export const actionIconButtonDangerClass =
  'p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded' as const;
